import { cn } from '@/shared/lib/utils';

const SIZE_CLASS = {
  sm: 'size-4 border-2',
  md: 'size-6 border-[2.5px]',
  lg: 'size-8 border-[3px]',
} as const;

interface SpinnerProps {
  size?: keyof typeof SIZE_CLASS;
  /** 스크린리더용 문구. 화면에 보이는 문구와 같이 쓰면 비워 둔다 */
  label?: string;
  className?: string;
}

/**
 * 로딩 스피너 — 디자인에 없어 토큰 색(accent)의 원형 테두리로 만든다.
 * 색은 currentColor 라 className 의 text-* 로 바꾼다 (예: 검정 버튼 안에서는 text-fg-white).
 */
export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <span
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-current border-t-transparent text-fg-accent',
        SIZE_CLASS[size],
        className,
      )}
    />
  );
}
